// Hook powiazania pozycji oferty ze wspoldzielona kalkulacja -
// POST /sales-crm/clients/:cid/offers/:oid/positions/:pid/calculations/link

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmOfferCalculationLinkPayload {
  calculationId: number;
  /** Wymusza zastapienie wlasnej kalkulacji pozycji (jesli juz istnieje). */
  force?: boolean;
}

export type IPostSalesCrmOfferCalculationLinkResponse = ICommandResponseSuccess & {
  linkedCalculationId?: number;
};

const postSalesCrmOfferCalculationLink = (
  clientId: number,
  offerId: string,
  positionId: number,
  payload: IPostSalesCrmOfferCalculationLinkPayload
): Promise<IPostSalesCrmOfferCalculationLinkResponse> =>
  axios.post(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/calculations/link`,
    payload
  );

export const usePostSalesCrmOfferCalculationLink = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<
    IPostSalesCrmOfferCalculationLinkResponse,
    IError,
    IPostSalesCrmOfferCalculationLinkPayload
  >
) =>
  useMutation(
    (payload: IPostSalesCrmOfferCalculationLinkPayload) =>
      postSalesCrmOfferCalculationLink(clientId, offerId, positionId, payload),
    options
  );
